import { createContext } from "react"

export const initialState = {}

const initialDispatch = {}

export const RoadwayStreetViewStateContext = createContext(initialState)
export const RoadwayStreetViewDispatchContext = createContext(initialDispatch)